import * as React from "react"
import { useTranslation } from "react-i18next"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import { IProduct } from "shared/hubrise/models"
import { Product, Sku } from "shared/hubrise/utils"

import { Title, SkuButton, Skus, StyledSkus } from "./Styles"

interface SkuSelectorProps {
  product: IProduct
  skuName: string
  setSkuName: (name: string) => void
}

const SkuSelector = ({ product, skuName, setSkuName }: SkuSelectorProps): JSX.Element | null => {
  const { t } = useTranslation()
  const { variantRef } = useCatalogNavigation()

  if (!Product.isMultiSku(product)) return null

  const skus = product.skus.filter((sku) => Sku.isVisibleInPreview(sku, variantRef))

  return (
    <StyledSkus>
      <Title>{t("preview.popup.product.select_sku")}</Title>
      <Skus>
        {skus.map((sku) => (
          <SkuButton
            key={sku.name}
            isActive={sku.name === skuName}
            useBoldable={true}
            onClick={() => setSkuName(sku.name)}
          >
            {sku.name}
          </SkuButton>
        ))}
      </Skus>
    </StyledSkus>
  )
}

export default SkuSelector
